import React from "react";
import Flagship from "../../core/flagship";
import DropzoneS3Uploader from "react-dropzone-s3-uploader";
import { empty, getFormattedValue } from "../../utils/helpers";
import { Link } from "react-router";
import {
  Segment,
  Card,
  Icon,
  Header,
  Button,
  Loader,
  Label
} from "semantic-ui-react";
import connect from "react-redux/es/connect/connect";

class FileUploadField extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.getFiles = this.getFiles.bind(this);
    this.getSignedUrl = this.getSignedUrl.bind(this);
    this.uploadError = this.uploadError.bind(this);
    this.missingFiles = this.missingFiles.bind(this);
    this.handleFinishedUpload = this.handleFinishedUpload.bind(this);
    this.uploadProgress = this.uploadProgress.bind(this);
    this.uploaderChildren = this.uploaderChildren.bind(this);

    this.s3Url = "https://" + Flagship.config.awsBucket + ".s3.amazonaws.com";
    this.state = {
      files: [],
      loading: true,
      uploading: false,
      progress: 0
    };
  }

  componentDidMount() {
    this.getFiles();
  }

  handleFinishedUpload(data) {
    this.setState({
      uploading: false,
      progress: 0
    });

    this.props.onChange(null, this.props.folder);

    this.getFiles();

    Flagship.notify("File Uploaded.", "success");
    Flagship.event(
      "file-upload",
      data.file.name,
      this.props.recordId,
      this.props.userId
    );
  }

  uploadError(err) {
    Flagship.error(
      "Upload failed. " + err,
      this.props.recordId,
      this.props.userId
    );
  }

  getFiles() {
    let self = this;
    Flagship.get(
      "s3/list",
      {
        bucket: Flagship.config.awsBucket,
        folder: self.props.folder
      },
      function(response) {
        if (response.data.success === true && response.data.files !== null) {
          self.setState({
            files: response.data.files,
            loading: false
          });
        } else if (response.data.files === null) {
          self.setState({
            files: [],
            loading: false
          });
        } else {
          self.setState({
            files: [],
            loading: false
          });
          Flagship.error(
            "Failed to list files.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function(err) {
        self.setState({
          loading: false
        });
        Flagship.error(
          "Failed to list files: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  getSignedUrl(file, callback) {
    let self = this;
    Flagship.get(
      "s3/sign",
      {
        bucket: Flagship.config.awsBucket,
        objectName: self.props.folder + "/" + file.name,
        contentType: file.type
      },
      function(data) {
        callback(data.data);
      },
      function(err) {
        if (typeof console.error === "function") {
          console.error(err);
        }
      }
    );
  }

  onViewDownloadFile(file) {
    window.open(
      Flagship.config.apiBase + "file?path=" + encodeURIComponent(file)
    );
  }

  onDeleteFile(file) {
    let self = this;
    Flagship.get(
      "s3/deleteFile",
      {
        bucket: Flagship.config.awsBucket,
        objectName: file,
        folder: self.props.folder
      },
      function() {
        self.getFiles();
      },
      function(err) {
        if (typeof console.error === "function") {
          Flagship.notify(
            "An error occurred while trying to delete the file: " + err,
            "error"
          );
        }
      }
    );
  }

  missingFiles() {
    return this.state.loading ? (
      <Loader
        color="blue"
        className="flagship-loader"
        active
        inline="centered"
      />
    ) : null;
  }

  uploadProgress(uploader, progress) {
    this.setState({
      uploading: true,
      progress
    });
  }

  uploaderChildren() {
    if (this.state.uploading) {
      return (
        <div className="upload-progress">
          <Loader
            color="blue"
            className="flagship-loader"
            active
            inline="centered"
          />
          <div className="uploading-text">
            {typeof this.state.progress === "number"
              ? this.state.progress + "%"
              : this.state.progress}
          </div>
        </div>
      );
    }
    return (
      <p className="uploader-inner">
        <strong>Drag & Drop</strong> Files or
        <br />
        <Button content="Click Here" />
        <br /> to Upload.
      </p>
    );
  }

  render() {
    let self = this;
    let children = this.uploaderChildren;

    const uploadOptions = {
      server: "http://flagship.dev",
      s3path: this.props.folder,
      getSignedUrl: this.getSignedUrl,
      uploadRequestHeaders: {},
      multi: this.props.multi === true
    };

    return (
      <div>
        <Label className="single-field-label file-field-label" size="large">
          {this.props.label}
          {this.props.required === "1" ||
          this.props.required === true ||
          this.props.required === 1 ? (
            <Icon
              color="red"
              size="tiny"
              className="asterisk"
              name="asterisk"
            />
          ) : null}
        </Label>
        <Segment className="file-field-upload-container">
          <Card.Group className="field-files cf">
            {this.state.files.length
              ? this.state.files.map(function(file, i) {
                  return (
                    <Card key={"file-" + i} className="single-file">
                      <Card.Content>
                        <Icon
                          onClick={() => {
                            self.onDeleteFile(file.Key);
                          }}
                          name="delete"
                          circular
                          className="delete-file float-right"
                        />
                        <Card.Header>
                          <Header as="h4">
                            <Link
                              target="_blank"
                              to={
                                Flagship.config.apiBase +
                                "file?path=" +
                                encodeURIComponent(file.Key)
                              }
                            >
                              {file.Key.replace(/^.*[\\\/]/, "")}
                            </Link>
                          </Header>
                        </Card.Header>
                        <Card.Meta>
                          {getFormattedValue(file.Size, "filesize")}
                        </Card.Meta>
                      </Card.Content>
                    </Card>
                  );
                })
              : self.missingFiles()}
          </Card.Group>
          <br />
          {!empty(this.props.prefix) ? (
            <div dangerouslySetInnerHTML={{ __html: this.props.prefix }}></div>
          ) : null}

          {this.props.userRole !== "ae" ? (
            <DropzoneS3Uploader
              onFinish={this.handleFinishedUpload.bind(this)}
              onProgress={this.uploadProgress}
              onError={this.uploadError}
              children={children}
              passChildrenProps={false}
              s3Url={this.s3Url}
              maxSize={1024 * 1024 * 10000}
              upload={uploadOptions}
              className="file-upload-area file-upload-small"
              style={{
                width: "100%",
                height: 160,
                border: "dashed 2px #999",
                borderRadius: 5,
                position: "relative",
                cursor: "pointer",
                overflow: "hidden"
              }}
            />
          ) : (
            <span>You don't have permission to upload files.</span>
          )}
          <br />
          {!empty(this.props.suffix) ? (
            <div dangerouslySetInnerHTML={{ __html: this.props.suffix }}></div>
          ) : null}
        </Segment>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userRole: state.main.userRole
  };
}

export default connect(mapStateToProps, null)(FileUploadField);



// WEBPACK FOOTER //
// ./src/components/misc/FileUploadField.js